import PortfolioManagerPage from 'components/PortfolioManagerPage';

const route = (path, name) => ({
  path,
  name,
  component: PortfolioManagerPage,
});

export default function createPortfolioManagerRoutes() {
  return [
    route('/portfolio-manager', 'portfolio-manager-home'),
    route('/status', 'portfolio-manager-status'),
    route('/status/:status', 'portfolio-manager-status-filter'),
    route('/house-registration/success', 'portfolio-manager-registration-success'),
    route('/house-registration', 'portfolio-manager-registration'),
    route('/drafts/:draftSection', 'portfolio-manager-draft'),
    route('/photos', 'portfolio-manager-photos'),
    route('/visits', 'portfolio-manager-visits'),
    route('/property/:propertyId/:section', 'portfolio-manager-property-section'),
    route('/search/:term', 'portfolio-manager-search'),
    route('/rent-offers/:offerStatus', 'portfolio-manager-rent-offers'),
    route('/rent-offer/canceled/details', 'portfolio-manager-rent-offer-canceled'),
    route('/rent-offer/details', 'portfolio-manager-rent-offer-details'),
    route('/rent-offer/:propertyId/closing/:proposalId', 'portfolio-manager-rent-closing'),
    route('/rent-offer/:propertyId/negotiation/:offerId', 'portfolio-manager-rent-negotiation'),
    route('/sale-offers/internal/:offerStatus', 'portfolio-manager-sale-offers-internal'),
    route('/sale-offers/:offerStatus', 'portfolio-manager-sale-offers'),
    route('/sale-offer/details/tic', 'portfolio-manager-sale-offer-tic'),
    route('/sale-offer/details', 'portfolio-manager-sale-offer-details'),
    route('/price-calculator/results', 'portfolio-manager-price-results'),
    route('/price-calculator', 'portfolio-manager-price-calculator'),
    route('/pricing-report/:hash', 'portfolio-manager-pricing-report'),
    route('/listing-performance/report-setup/:propertyId', 'portfolio-manager-listing-report-setup'),
    route('/listing-performance/report/:hash', 'portfolio-manager-listing-report'),
    route('/listing-performance', 'portfolio-manager-listing-performance'),
    route('/reports/pos', 'portfolio-manager-pos-report'),
    route('/company-profile', 'portfolio-manager-company-profile'),
    route('/members', 'portfolio-manager-members'),
    route('/operation-areas', 'portfolio-manager-operation-areas'),
    route('/integration', 'portfolio-manager-integration'),
    route('/user-profile/:personUuid', 'portfolio-manager-user-profile'),
    route('/confirm-user-data', 'portfolio-manager-confirm-user-data'),
    route('/profile-conflict/unsuported', 'portfolio-manager-profile-conflict-unsupported'),
    route('/profile-conflict', 'portfolio-manager-profile-conflict'),
    route('/first-login', 'portfolio-manager-first-login'),
    route('/first-access', 'portfolio-manager-first-access'),
    route('/reset-password', 'portfolio-manager-reset-password'),
    route('/create-new-password', 'portfolio-manager-create-new-password'),
    route('/esqueci-minha-senha', 'portfolio-manager-forgot-password'),
    route('/nova-senha', 'portfolio-manager-new-password'),
    route('/lead-1001/:propertyId/:businessContext', 'portfolio-manager-lead-detail'),
  ];
}
